module.exports = __webpack_public_path__ + "media/images/weather/268_day-c24d6493166510fb8267e65e820d6d7c.png";